import {
	getDevDocsSmartFolderProperties,
	hasDevDocsContentProperty,
	type DevDocsContentPropertyNode,
} from '../DevDocsProperties.ts';

const DEV_DOCS_CONTAINER_APPS = new Set(['bitbucket', 'github']);

const isDevDocsContainerApp = (containerApp: string | null | undefined): boolean =>
	Boolean(containerApp && DEV_DOCS_CONTAINER_APPS.has(containerApp.trim().toLowerCase()));

export type DevDocsContentPropertyNodes = readonly DevDocsContentPropertyNode[] | null | undefined;

export type DevDocsFolderOwnershipSources = {
	readonly propertyCollections?: readonly DevDocsContentPropertyNodes[];
};

export const isDevDocsOwnedFolder = ({
	propertyCollections = [],
}: DevDocsFolderOwnershipSources): boolean => {
	if (propertyCollections.some((properties) => hasDevDocsContentProperty(properties))) {
		return true;
	}

	return propertyCollections.some((properties) =>
		isDevDocsContainerApp(getDevDocsSmartFolderProperties(properties)?.containerApp),
	);
};

export const shouldExcludeDevDocsAutoSync = ({
	ownershipProperties,
	smartFolderProperties,
}: {
	readonly ownershipProperties?: DevDocsContentPropertyNodes;
	readonly smartFolderProperties?: DevDocsContentPropertyNodes;
}): boolean =>
	isDevDocsOwnedFolder({
		propertyCollections: [ownershipProperties, smartFolderProperties],
	});
